export function AirplayButton() {
  return null;
}
export function useAirplayConnectivity() {
  return false;
}
export default AirplayButton;
